<template>
  <div class="password-strength small">
    <div><strong>Password Requirements:</strong></div>
    <ul :class="{ 'errors-list': true, 'has-errors' : errors.has(fieldData.field_name) }" class="pl-3">
      <li v-for="(customeErrorMessage, i) in validationMessages" :key="i"
       :class="{
          'text-invalid' : validationErrors.includes(i), // Error exists in errors
          'text-valid' : (!validationErrors.includes(i) && fieldData.field_value), // Error does not exist AND field not empty
          }">
        {{ customeErrorMessage }}
      </li>
    </ul>

    {{ fieldValue }}
  </div>
</template>

<script>
import veeConfig from '../../../custom-error-messages';

/**
 * UI for helping the user create a strong password.
 *
 * There are two hacks in here. First, the `errors.has()` must be in the template
 * to allow the validator's errors to be referenced. Second, the computed property
 * `fieldValue` is instead of checking the errors in updated() because an infinite
 * loop is created if the template changes.
 */
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData'],
  data() {
    return {
      validationMessages: {}, // List of all possible validation error messages
      validationErrors: [], // List of validation rules that are invalid
      fieldRules: null, // List of the names of all validation rules on the field
    };
  },
  computed: {
    fieldValue: function fieldValue() {
      /* eslint-disable */
      this.fieldData.field_value; // TODO: Use a watcher instead of a computed property that is triggered on input

      this.validationErrors = []; // Reset before adding current validation errors

      this.$validator.errors.items.forEach((item) => {
        this.validationErrors.push(item.rule);
      });

      return '';
    },
  },
  mounted() {
    const field = this.$validator.fields.find({ name: this.fieldData.field_name });
    this.fieldRules = field.rules;

    /**
     * Create a list of the messages that belong to all of the validation rules.
     * This is instead of using the usual `errors.has()` since the validation
     * messages must be shown at all times and only styled different according
     * to validation success/fail.
     */
    Object.keys(this.fieldRules).forEach((rule) => {
      if (typeof veeConfig.dictionary.en.messages[rule] === 'function') { // TODO: Also check default messages
        this.validationMessages[rule] = veeConfig.dictionary.en.messages[rule](this.fieldData.field_name, this.fieldRules[rule]);
      }
    });
  },
};
</script>

<style scoped>
ul.errors-list{
  padding-left: 1.275rem !important;
  line-height: 1.125rem;
}
  ul.errors-list li{
    padding:0.125rem 0 !important;
  }

ul.errors-list > li.text-valid {
  list-style-image: url("../../../assets/check-circle-green.png");
}

ul.errors-list > li.text-invalid {
  list-style-image: url("../../../assets/times-circle-red.png");
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/alerts/PasswordStrength.vue?38587851